export default __webpack_public_path__ + "static/media/Artboard.fbf3fc91.png";